import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import avo from 'analytics/avo';
import ProductCardContext from 'data-hooks/context/ProductCardContext';
import mergeProductAndSelectedOptionData from './helpers/mergeProductAndSelectedOptionData';
import ProductCardStaticUI from './ProductCardStaticUI';
import getProductCardLayoutFlags from './helpers/getProductCardLayoutFlags';

// This provides a new simple interface to render a ProductCard. As we
// gradually move to this component, we should be able to identify which props
// in the main ProductCard component are unnecessary. After migration, we
// should be able to remove all unnecessary props and state from the main
// ProductCard, then we can merge this component into the ProductCard.
const ProductCardStatic = t0 => {
  const $ = _c(66);
  const {
    analyticsComponentName: t1,
    campaign,
    disableImageLazyLoading,
    prioritizeImage,
    enableMobileCarousel,
    filterStateKey: t2,
    hidden,
    id,
    initialOptionId: t3,
    isClearance,
    isFavorited,
    layout: t4,
    meta,
    moreVariantsCount,
    name,
    onClick,
    onDisplayInShowroomSlug,
    path,
    position,
    productFamily,
    productLabel,
    productType,
    quickship,
    secondaryImage,
    secondaryImageCropData,
    slug,
    variantsToShow,
    variantsTotal,
    isHotspotCard,
    bypass_stock
  } = t0;
  const analyticsComponentName = t1 === undefined ? avo.Component.PRODUCT_CARD : t1;
  const filterStateKey = t2 === undefined ? "" : t2;
  const initialOptionId = t3 === undefined ? null : t3;
  const layout = t4 === undefined ? "full" : t4;
  const [selectedOptionId, setSelectedOptionId] = useState(initialOptionId);
  let t5;
  if ($[0] !== initialOptionId) {
    t5 = () => {
      setSelectedOptionId(prevSelectedOptionId => {
        if (prevSelectedOptionId !== initialOptionId) {
          return initialOptionId;
        }
        return prevSelectedOptionId;
      });
    };
    $[0] = initialOptionId;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const resetToInitialOptionId = t5;
  let t6;
  if ($[2] !== resetToInitialOptionId) {
    t6 = () => {
      resetToInitialOptionId();
    };
    $[2] = resetToInitialOptionId;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] !== filterStateKey || $[5] !== name || $[6] !== resetToInitialOptionId) {
    t7 = [resetToInitialOptionId, filterStateKey, name];
    $[4] = filterStateKey;
    $[5] = name;
    $[6] = resetToInitialOptionId;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  useEffect(t6, t7);
  let selectedOption;
  let showAttributes;
  let showProductLabel;
  let showShowroomInfo;
  let showStockInfo;
  let showSwatches;
  let t8;
  if ($[8] !== bypass_stock || $[9] !== campaign || $[10] !== enableMobileCarousel || $[11] !== id || $[12] !== isClearance || $[13] !== isFavorited || $[14] !== layout || $[15] !== meta || $[16] !== moreVariantsCount || $[17] !== name || $[18] !== onDisplayInShowroomSlug || $[19] !== path || $[20] !== position || $[21] !== productFamily || $[22] !== productLabel || $[23] !== productType || $[24] !== quickship || $[25] !== secondaryImage || $[26] !== secondaryImageCropData || $[27] !== selectedOptionId || $[28] !== slug || $[29] !== variantsToShow || $[30] !== variantsTotal) {
    selectedOption = variantsToShow?.find(option => !!selectedOptionId && option.id === selectedOptionId) ?? variantsToShow?.[0];
    let t9;
    if ($[38] !== layout) {
      t9 = getProductCardLayoutFlags(layout);
      $[38] = layout;
      $[39] = t9;
    } else {
      t9 = $[39];
    }
    ({
      showAttributes,
      showProductLabel,
      showShowroomInfo,
      showStockInfo,
      showSwatches
    } = t9);
    t8 = mergeProductAndSelectedOptionData({
      campaign,
      enableMobileCarousel,
      id,
      isClearance,
      isFavorited,
      moreVariantsCount,
      name,
      onDisplayInShowroomSlug,
      path,
      position,
      productFamily,
      productLabel,
      productType,
      quickship,
      secondaryImage,
      secondaryImageCropData,
      selectedOption,
      slug,
      variantsToShow,
      variantsTotal,
      meta,
      bypass_stock
    });
    $[8] = bypass_stock;
    $[9] = campaign;
    $[10] = enableMobileCarousel;
    $[11] = id;
    $[12] = isClearance;
    $[13] = isFavorited;
    $[14] = layout;
    $[15] = meta;
    $[16] = moreVariantsCount;
    $[17] = name;
    $[18] = onDisplayInShowroomSlug;
    $[19] = path;
    $[20] = position;
    $[21] = productFamily;
    $[22] = productLabel;
    $[23] = productType;
    $[24] = quickship;
    $[25] = secondaryImage;
    $[26] = secondaryImageCropData;
    $[27] = selectedOptionId;
    $[28] = slug;
    $[29] = variantsToShow;
    $[30] = variantsTotal;
    $[31] = selectedOption;
    $[32] = showAttributes;
    $[33] = showProductLabel;
    $[34] = showShowroomInfo;
    $[35] = showStockInfo;
    $[36] = showSwatches;
    $[37] = t8;
  } else {
    selectedOption = $[31];
    showAttributes = $[32];
    showProductLabel = $[33];
    showShowroomInfo = $[34];
    showStockInfo = $[35];
    showSwatches = $[36];
    t8 = $[37];
  }
  const mergedData = t8;
  const t9 = selectedOption?.id;
  let t10;
  if ($[40] !== campaign || $[41] !== isClearance || $[42] !== isFavorited || $[43] !== mergedData || $[44] !== position || $[45] !== productFamily || $[46] !== productType || $[47] !== showAttributes || $[48] !== showProductLabel || $[49] !== showShowroomInfo || $[50] !== showStockInfo || $[51] !== showSwatches || $[52] !== t9) {
    t10 = {
      ...mergedData,
      showAttributes,
      showProductLabel,
      showShowroomInfo,
      showStockInfo,
      showSwatches,
      campaign,
      isClearance,
      isFavorited,
      position,
      productFamily,
      productType,
      selectedOptionId: t9,
      setSelectedOptionId
    };
    $[40] = campaign;
    $[41] = isClearance;
    $[42] = isFavorited;
    $[43] = mergedData;
    $[44] = position;
    $[45] = productFamily;
    $[46] = productType;
    $[47] = showAttributes;
    $[48] = showProductLabel;
    $[49] = showShowroomInfo;
    $[50] = showStockInfo;
    $[51] = showSwatches;
    $[52] = t9;
    $[53] = t10;
  } else {
    t10 = $[53];
  }
  const dataWithActions = t10;
  const productCardData = dataWithActions;
  let t11;
  if ($[54] !== analyticsComponentName || $[55] !== disableImageLazyLoading || $[56] !== enableMobileCarousel || $[57] !== hidden || $[58] !== isHotspotCard || $[59] !== layout || $[60] !== onClick || $[61] !== prioritizeImage) {
    t11 = <ProductCardStaticUI analyticsComponentName={analyticsComponentName} disableImageLazyLoading={disableImageLazyLoading} prioritizeImage={prioritizeImage} hidden={hidden} enableMobileCarousel={enableMobileCarousel} onClick={onClick} isHotspotCard={isHotspotCard} layout={layout} />;
    $[54] = analyticsComponentName;
    $[55] = disableImageLazyLoading;
    $[56] = enableMobileCarousel;
    $[57] = hidden;
    $[58] = isHotspotCard;
    $[59] = layout;
    $[60] = onClick;
    $[61] = prioritizeImage;
    $[62] = t11;
  } else {
    t11 = $[62];
  }
  let t12;
  if ($[63] !== productCardData || $[64] !== t11) {
    t12 = <ProductCardContext.Provider value={productCardData}>{t11}</ProductCardContext.Provider>;
    $[63] = productCardData;
    $[64] = t11;
    $[65] = t12;
  } else {
    t12 = $[65];
  }
  return t12;
};
ProductCardStatic.propTypes = {
  analyticsComponentName: PropTypes.string,
  campaign: PropTypes.string,
  enableMobileCarousel: PropTypes.bool,
  filterStateKey: PropTypes.string,
  hidden: PropTypes.bool,
  id: PropTypes.number.isRequired,
  initialOptionId: PropTypes.string,
  isHotspotCard: PropTypes.bool,
  isClearance: PropTypes.bool,
  isFavorited: PropTypes.bool,
  layout: PropTypes.oneOf(['full', 'mini', 'minimal', 'minimal-with-attributes', 'minimal-with-showroom']),
  meta: PropTypes.object,
  moreVariantsCount: PropTypes.number,
  name: PropTypes.string,
  onClick: PropTypes.func,
  onDisplayInShowroomSlug: PropTypes.string,
  path: PropTypes.string,
  position: PropTypes.number,
  productFamily: PropTypes.string,
  productLabel: PropTypes.string,
  productType: PropTypes.string,
  quickship: PropTypes.bool,
  secondaryImage: PropTypes.string,
  secondaryImageCropData: PropTypes.object,
  slug: PropTypes.string,
  bypass_stock: PropTypes.bool,
  variantsToShow: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    image: PropTypes.string,
    isOutOfStock: PropTypes.bool,
    label: PropTypes.string,
    minPrice: PropTypes.number,
    originalPrice: PropTypes.number,
    path: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    quickship: PropTypes.bool,
    sku: PropTypes.string
  })),
  variantsTotal: PropTypes.number
};
export default ProductCardStatic;